
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LogView } from '../../_models/LogView';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  })
}
let httpHeaders = new HttpHeaders()
  .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
  .set('Content-Type', 'application/json');
let options = {
  headers: httpHeaders
};


@Injectable({
  providedIn: 'root'
})
export class LogService {
  private baseUrl = environment.apiUrl + 'Log/';
  constructor(private http: HttpClient) { }

  //return this.http.post(this.baseUrl + 'SetUserFromTemplate',model, httpOptions);

  // GetOverAllDeviceStatus(Datetime:any): Observable<HttpResponse<any>> {
  //   return this.http.get<HttpResponse<any>>(this.baseUrl + 'RealTimeLogView?Time='+Datetime, {
  //     headers: httpHeaders,
  //     observe: 'response'
  //   }
  //   );
  // }

  GetOverAllDeviceStatus(Datetime:any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.baseUrl + 'RealTimeLogView',Datetime, {
      headers: httpHeaders,
      observe: 'response'
    }
    );
  }

  GetAllLogs(DevID: any, FromDate: any, toDate: any): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.baseUrl + 'GetAllLogs?DeviceID=' + DevID + '&FromDate=' + FromDate + '&ToDate=' + toDate, {
      headers: httpHeaders,
      observe: 'response'
    }
    );
  }

}
